import Cookies from 'js-cookie';
import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from '../../../react-redux';
import { setConvTagTree, setConvTagList, setConvTagMap } from '../../../reducers/tag';
import {
  getCategoryList,
  getConversationTagsApi,
  updateConversationTagApi,
  deleteConversationTagApi,
  createConversationTagApi
} from '../api';
import tagSelector from '../selector';
import { convertTagMap, convertTagTree } from '@/utils';

const { parseConvTag, getConvTag, getConvTagTreeList } = tagSelector;
const entId = window.parseInt(Cookies.get('_enterprise_id'));

let currentRequest;

const useConvTag = () => {
  const convTagTree = useSelector(state => state.getIn(['tag', 'convTagTree']));
  const convTagList = useSelector(state => state.getIn(['tag', 'convTagList']));
  const convTagMap = useSelector(state => state.getIn(['tag', 'convTagMap']));
  // const convTag = parseConvTag(convTagSetting);
  const dispatch = useDispatch();

  const getConversationTagTree = () => Promise.all([getCategoryList(1), getConversationTagsApi({ entId })]);

  const handleGetConvTag = useCallback(() => {
    const request = currentRequest || getConversationTagTree();
    currentRequest = request;
    return request
      .then(([list, tags]) => {
        dispatch(setConvTagTree(convertTagTree(list, tags)));
        dispatch(setConvTagList(tags));
        dispatch(setConvTagMap(convertTagMap(tags)));
      })
      .finally(() => {
        currentRequest = null;
      });
  }, []);

  useEffect(() => {
    handleGetConvTag();
  }, []);

  return {
    convTagTree,
    convTagList,
    convTagMap,
    handleGetConvTag,
    handleGetConvTagById: () => {},
    // handleGetConvTagById,
    updateConversationTagApi,
    deleteConversationTagApi,
    createConversationTagApi
  };
};

export default useConvTag;
